import { Checkbox, ListItemText, MenuItem } from "@mui/material"

export function RegimeStateFilterOption({ item, index, selectedStates = [], onToggleState }) {
    const checked = selectedStates.includes(item.id)
    const isFirst = index === 0

    return (
        <MenuItem
            dense
            onClick={toggle}
            role="menuitemcheckbox"
            aria-checked={checked}
            autoFocus={isFirst}
            tabIndex={isFirst ? 0 : -1}
            data-cy={`regime-state-filter-option-${item.id}`}
        >
            <Checkbox
                size="small"
                edge="start"
                checked={checked}
                tabIndex={-1}
                disableRipple
                inputProps={{ "aria-hidden": true, tabIndex: -1 }}
            />
            <ListItemText primary={item.label} />
        </MenuItem>
    )

    function toggle() {
        onToggleState(item.id)
    }
}
